import { materialLoader } from "core/materialLoader"
export default {
  components: {
    ...materialLoader.getToolBarMixins().mixins,
    alignHelper: () => import("../../toolbar-option-components/utilsComponents/alignHelper/alignHelper.vue"),

    emptyLayoutComponent: () => import("../../toolbar-option-components/emptyLayoutComponent/emptyLayoutComponent.vue"),
    animateSet: () => import("./animate-set.vue"),
    bigScreenAnimateSet: () => import("./bigScreen-animate-set.vue"),

    layoutComponentBigScreenData: () =>
      import("../../toolbar-option-components/layoutComponentBigScreen/layoutComponent-data.vue"),
    layoutComponentBigScreenSetting: () =>
      import("../../toolbar-option-components/layoutComponentBigScreen/layoutComponent-setting.vue"),
    layoutComponentBigScreenStyle: () =>
      import("../../toolbar-option-components/layoutComponentBigScreen/layoutComponent-style.vue"),
    layoutComponentBigScreenConfig: () =>
      import("../../toolbar-option-components/layoutComponentBigScreen/layoutComponent-config.vue"),
    layoutComponentBigScreenListPageConfig: () =>
      import("../../toolbar-option-components/layoutComponentBigScreen/layoutComponent-config-listPage.vue"),

    layoutComponentData: () => import("../../toolbar-option-components/layoutComponent/layoutComponent-data.vue"),
    layoutComponentSetting: () => import("../../toolbar-option-components/layoutComponent/layoutComponent-setting.vue"),
    layoutComponentStyle: () => import("../../toolbar-option-components/layoutComponent/layoutComponent-style.vue"),
    layoutComponentConfig: () => import("../../toolbar-option-components/layoutComponent/layoutComponent-config.vue"),
    layoutComponentListPageConfig: () =>
      import("../../toolbar-option-components/layoutComponent/layoutComponent-config-listPage.vue"),

    emptyLayoutComponentBigScreenData: () =>
      import("../../toolbar-option-components/layoutComponentBigScreen/layoutComponent-data.vue"),
    emptyLayoutComponentBigScreenSetting: () =>
      import("../../toolbar-option-components/layoutComponentBigScreen/layoutComponent-setting.vue"),
    emptyLayoutComponentBigScreenStyle: () =>
      import("../../toolbar-option-components/layoutComponentBigScreen/layoutComponent-style.vue"),
    emptyLayoutComponentBigScreenConfig: () =>
      import("../../toolbar-option-components/layoutComponentBigScreen/layoutComponent-config.vue"),

    emptyLayoutComponentData: () => import("../../toolbar-option-components/layoutComponent/layoutComponent-data.vue"),
    emptyLayoutComponentSetting: () =>
      import("../../toolbar-option-components/layoutComponent/layoutComponent-setting.vue"),
    emptyLayoutComponentStyle: () =>
      import("../../toolbar-option-components/layoutComponent/layoutComponent-style.vue"),
    emptyLayoutComponentConfig: () =>
      import("../../toolbar-option-components/layoutComponent/layoutComponent-config.vue"),
    emptyLayoutComponentListPageConfig: () =>
      import("../../toolbar-option-components/layoutComponent/layoutComponent-config-listPage.vue"),
    colsComponentSetting: () => import("../../toolbar-option-components/colsComponent/colsComponent-setting"),
    colsComponentData: () => import("../../toolbar-option-components/colsComponent/colsComponent-data"),
    colsComponentStyle: () => import("../../toolbar-option-components/colsComponent/colsComponent-style"),

    colsComponentBigScreenSetting: () =>
      import("../../toolbar-option-components/colsComponentBigScreen/colsComponent-setting"),
    colsComponentBigScreenData: () =>
      import("../../toolbar-option-components/colsComponentBigScreen/colsComponent-data"),
    colsComponentBigScreenStyle: () =>
      import("../../toolbar-option-components/colsComponentBigScreen/colsComponent-style"),
    globalSetting: () => import("../../toolbar-option-components/container/global-setting.vue"),
    subPageSetting: () => import("../../toolbar-option-components/container/subPage-setting.vue"),
    subPageConfig: () => import("../../toolbar-option-components/container/subPage-config.vue"),
    containerSetting: () => import("../../toolbar-option-components/container/container-options-setting.vue"),
    containerStyle: () => import("../../toolbar-option-components/container/container-style.vue"),
    containerAnimate: () => import("../../toolbar-option-components/container/container-animate.vue"),
    bigScreenContainerSetting: () =>
      import("../../toolbar-option-components/container/bigScreen-container-options-setting.vue"),

    bindEvent: () => import("../../toolbar-option-components/event/event.vue"),

    pageSetting: () => import("../../toolbar-option-components/page/page-setting.vue"),

    //  产品组合的组件，如系统组件
    productComponentStyle: () => import("../../toolbar-option-components/styles/product-style.vue"),
    gridSetting: () => import("materials/pageLayout/toolbars/grid-options-setting.vue"),
    pageLayoutComponentSetting: () => import("materials/pageLayout/toolbars/pageLayout-options-setting.vue"),
    pageLayoutComponentConfig: () => import("materials/pageLayout/toolbars/pageLayout-options-config.vue"),
    drawerComponentSetting: () => import("materials/pageLayout/toolbars/drawer-options-setting.vue"),
    drawerComponentConfig: () => import("materials/pageLayout/toolbars/drawer-options-config.vue"),
    drawerComponentStyle: () => import("materials/pageLayout/toolbars/drawer-options-style.vue"),
    cellLayoutComponentSetting: () => import("materials/pageLayout/toolbars/cellLayout-options-setting.vue"),
    cellLayoutComponentConfig: () => import("materials/pageLayout/toolbars/cellLayout-options-config.vue"),
    cellPageLayoutComponentSetting: () => import("materials/pageLayoutComponent/toolbars/cellLayout-options-setting.vue"),
    cellPageLayoutComponentConfig: () => import("materials/pageLayoutComponent/toolbars/cellLayout-options-config.vue"),
    // layoutCanvasComponentSetting: () => import("materials/layoutCanvas/toolbars/layoutCanvas-options-setting.vue"),
    cxPie3DData: () => import("materials/bigScreen/pie3D/toolbars/pie3D-options-data.vue"),
    cxPie3DStyle: () => import("materials/bigScreen/pie3D/toolbars/pie3D-options-style.vue"),
    cxPie3DSetting: () => import("materials/bigScreen/pie3D/toolbars/pie3D-options-setting.vue"),
    dataGridCellComponentSetting: () => import("materials/dataGrid/toolbars/dataGridCell-options-setting.vue"),
    dataGridCellComponentData: () => import("materials/dataGrid/toolbars/dataGridCell-options-data.vue"),

    cxSlider: () => import("modules/components/cxSlider.vue")
  }
}
